import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ExpenseReportStatus, isMobile } from 'app/core/helpers/constants';
import { ExpenseReportHistory } from '../../../../core/models/expense-report-history';

@Component({
  selector: 'app-expense-report-history-details',
  templateUrl: './expense-report-history-details.component.html',
  styleUrls: ['./expense-report-history-details.component.scss'],
  providers: [TranslatePipe]
})
export class ExpenseReportHistoryDetailsComponent implements OnInit {

  @Input() report: ExpenseReportHistory;
  @Input() subdomain: string;
  public isMobile = false;
  public ExpenseReportStatus = ExpenseReportStatus;

  constructor() { }

  ngOnInit(): void {
    this.isMobile = isMobile();
  }
}
